import { Injectable } from '@angular/core';
import { IAdviceDay, IAdviceReference, IAllAdviceList, ISingleAdviceDay } from '@interfaces';
import { SetAdviceDayTipsListAction, SetAllAdviceTipsWithPageNumAction, SetCurrentSingleAdviceDayAction } from '../../../store/actions';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { AppState } from '@appStates';
import { RestUrlService, TypeUrl } from './settings/rest-url.service';
import { LocalizationService } from '../localization.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AdvicesApiService {
  private readonly _url: string;

  constructor(
    private readonly http: HttpClient,
    private readonly store: Store<AppState>,
    private readonly urlRest: RestUrlService,
    private readonly localizationService: LocalizationService
  ) {
    this._url = 'https:' + this.urlRest.getUrl(TypeUrl.rest);
  }

  public getAdviceDayTips(): void {
    this.http.get(this._url + '/api/main/day-advice').subscribe((response: IAdviceDay[]) => {
      this.store.dispatch(SetAdviceDayTipsListAction({ list: response }));
    });
  }

  public getSingleAdviceDayTip(id: string): void {
    this.http.get<ISingleAdviceDay>(this._url + `/api/day-advice/full/${id}`)
      .pipe(
        map((adviceDay: ISingleAdviceDay) => {
          return {
            ...adviceDay,
            urlsMap: this.addUrlsMapToAdviceDay(adviceDay)
          };
        })
      )
      .subscribe((singleAdvice: ISingleAdviceDay) => {
        this.store.dispatch(SetCurrentSingleAdviceDayAction(
          {
            advice:
            {
              ...singleAdvice,
              listItems: this.addHrefLinkToAdviceListItems(singleAdvice),
            }
          }
        ));
      });
  }

  public getAllAdvicesWithPagesNum(pageNum: number): void {
    this.http.get(this._url + `/api/day-advice/all/${pageNum}`)
      .subscribe((response: IAllAdviceList) => {
        this.store.dispatch(SetAllAdviceTipsWithPageNumAction({ data: response }));
      });
  }

  public getSearchAdviceDayTips(pageNum: number, searchValue: string): void {
    const params: HttpParams = new HttpParams()
      .set('pattern', searchValue);
    this.http.get(this._url + `/api/day-advice/search/${pageNum}`, { params })
      .subscribe((response: IAllAdviceList) => {
        this.store.dispatch(SetAllAdviceTipsWithPageNumAction({ data: response }));
      });
  }

  private addUrlsMapToAdviceDay(adviceDay: ISingleAdviceDay): Record<number, string[]> {
    const urlsMap: Record<number, string[]> = {};
    if (adviceDay?.adviceReferences && Array.isArray(adviceDay.adviceReferences)) {

      adviceDay.adviceReferences.forEach((reference: IAdviceReference) => {
        if (reference.info === '2') {
          urlsMap[reference.refId] = this.localizationService.getReturnParamsLang(['catalog', reference.url]);
        }
        if (reference.info === '3') {
          urlsMap[reference.refId] = this.localizationService.getReturnParamsLang(['category', reference.url]);
        }
      });

    }

    return urlsMap;
  }

  private addHrefLinkToAdviceListItems(singleAdvice: ISingleAdviceDay): string[] {
    return [...singleAdvice.listItems].map((item) => {
      if (/[0-9]/.test(item)) {
        const element: HTMLParagraphElement = document.createElement('p');
        element.innerHTML = item;
        const spans: HTMLCollectionOf<HTMLSpanElement> = element.getElementsByTagName('span');
        Array.from(spans).map((span: HTMLSpanElement) => {
          if (span?.hasAttribute('id')) {
            const spanId: number = Number(span.getAttribute('id'));
            const linkForHref: string = '/' + singleAdvice.urlsMap[spanId].join('/');
            const linkContent: string = span.innerHTML;
            const link = document.createElement('a');
            link.setAttribute('href', linkForHref);
            link.innerHTML = linkContent;
            link.style.cssText = 'color: #449bd1; text-decoration: underline; cursor: pointer; display: inline;';
            span.innerHTML = '';
            span.appendChild(link);
            return span;
          }
          return span;
        });
        return element.outerHTML;
      }
      return item;
    });
  }

}
